import { createAsyncThunk, current } from '@reduxjs/toolkit';
import axios from 'axios';
import { axiosCustom } from '../../../utils/axiosUser';

export const initStateGamePartnerUpdate = {
  gamePartnerUpdate: { data: null, loading: false, error: null },
};

export const gamePartnerUpdate = createAsyncThunk('user/gamePartnerUpdate', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosCustom
    .post(`/game/partner/update`, data)
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerGamePartnerUpdate = {
  [gamePartnerUpdate.pending]: (state) => {
    state.gamePartnerUpdate.loading = true;
  },
  [gamePartnerUpdate.fulfilled]: (state, action) => {
    state.gamePartnerUpdate.loading = false;
    state.gamePartnerUpdate.data = action.payload;
    state.gamePartnerUpdate.error = null;
  },
  [gamePartnerUpdate.rejected]: (state, action) => {
    state.gamePartnerUpdate.loading = false;
    state.gamePartnerUpdate.error = action.payload;
  },
};
